/** Variables VITE_*_URL — handoff Suite → modules (source unique). */
export const SUITE_MODULE_ENV_VARS = {
  product: "VITE_PRODUCT_URL",
  inventory: "VITE_INVENTORY_URL",
  autoid: "VITE_AUTOID_URL",
  erp: "VITE_ERP_URL",
  rh: "VITE_RH_URL",
  workforce: "VITE_WORKFORCE_URL",
  recruitment: "VITE_RECRUITMENT_URL",
  attendance: "VITE_ATTENDANCE_URL",
  security: "VITE_SECURITY_URL",
  notifications: "VITE_NOTIFICATIONS_URL",
  billing: "VITE_BILLING_URL",
  crm: "VITE_CRM_URL",
  finance: "VITE_FINANCE_URL",
  procurement: "VITE_PROCUREMENT_URL",
  hospitol: "VITE_HOSPITOL_URL",
  edu: "VITE_EDU_URL",
  mineportal: "VITE_MINEPORTAL_URL",
  subportal: "VITE_SUBPORTAL_URL",
  comex: "VITE_COMEX_URL",
  legal: "VITE_LEGAL_URL",
} as const;

export type SuiteHandoffModuleId = keyof typeof SUITE_MODULE_ENV_VARS;

/** Clés à valider au `vite build` production de itaas-suite. */
export const SUITE_MODULE_VITE_ENV_KEYS: readonly string[] = Object.values(
  SUITE_MODULE_ENV_VARS,
);

export function resolveModuleHandoffBaseUrl(options: {
  moduleId: string;
  envUrl?: string;
  devDefault?: string;
}): string {
  const envVar =
    SUITE_MODULE_ENV_VARS[options.moduleId as SuiteHandoffModuleId];
  const envUrl = options.envUrl?.trim();

  if (import.meta.env.PROD && !envUrl) {
    throw new Error(
      `Missing ${envVar ?? `VITE_*_URL for module "${options.moduleId}"`} in production build.`,
    );
  }

  const url = envUrl || options.devDefault;
  if (!url) {
    throw new Error(
      `URL produit non configurée pour le module « ${options.moduleId} ».`,
    );
  }

  return url.replace(/\/$/, "");
}
